module.exports = __webpack_public_path__ + "c5f50c44c5dfb0bba245474e87b47576.pdf";